export default "__VITE_ASSET___YKy$D_m__"